import React from "react";
import { PaymentRowProps } from "src/types/payment-row-props";
import moment from "moment";
import "./payment-row.component.sass";

export default function PaymentRow(props: PaymentRowProps) {
  const { from, to, amount } = props;
  const formattedMainDate = moment(new Date(to)).format("MMMM YYYY");
  const formattedFromToDate = `${moment(new Date(from)).format("MMMM DD, YYYY")} - ${moment(new Date(to)).format("MMMM DD, YYYY")}`;
  return (
    <div className="payment-row">
      <div className="main-date">{formattedMainDate}</div>
      <div className="from-to">{formattedFromToDate}</div>
      <div className="amount">€ {(amount / 100).toFixed(2)}</div>
    </div>
  );
}
